module.exports = __webpack_public_path__ + "static/elephant-360-a4ce89bdac308001aac170353ca7aa38.webm";